import { useEffect, useRef, useState } from 'react';

// Random display-only address, not a deployed token contract. Replace before launch.
export const TOKEN_CA_PLACEHOLDER =
  '0x7b3e91a4c8f206d5a09e64b17f2c8d5306a1e9bf';

export function AppFooter() {
  const [status, setStatus] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  async function copyAddress() {
    clearTimeout(timer.current);
    try {
      await navigator.clipboard.writeText(TOKEN_CA_PLACEHOLDER);
      setStatus('Copied');
    } catch {
      setStatus('Copy failed');
    }
    timer.current = setTimeout(() => setStatus(''), 2500);
  }
  return (
    <footer className="app-footer" aria-label="Project resources">
      <div className="app-footer-token">
        <span className="app-footer-name">runordie token</span>
        <button
          className="app-footer-ca"
          onClick={copyAddress}
          aria-label="Copy token address"
          title={'Temporary demo address: ' + TOKEN_CA_PLACEHOLDER}
        >
          <span className="app-footer-address">{TOKEN_CA_PLACEHOLDER}</span>
        </button>
        <span className="app-footer-status" role="status">
          {status}
        </span>
      </div>
      <div className="app-footer-resources" aria-label="Coming soon">
        {['X', 'Docs', 'Help'].map((name) => (
          <button
            key={name}
            disabled
            aria-label={name + ' — coming soon'}
            title="Coming soon"
          >
            {name}
          </button>
        ))}
      </div>
    </footer>
  );
}
